import { render, staticRenderFns } from "./pre_btn_control_tan.vue?vue&type=template&id=56de5512&scoped=true"
import script from "./pre_btn_control_tan.vue?vue&type=script&lang=js"
export * from "./pre_btn_control_tan.vue?vue&type=script&lang=js"
import style0 from "./pre_btn_control_tan.vue?vue&type=style&index=0&id=56de5512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de5512",
  null
  
)

export default component.exports